import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Divider,
  Upload,
  Tooltip,
  Badge,
  notification,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useSearchParams } from "react-router-dom";
import "../assets/css/common.css";

import {
  useCommentAddedSubscription,
  useCreateCommentMutation,
  useGetTicketQuery,
  useListCommentsQuery,
} from "../graphql/generated/hooks";
import { PlusOutlined, SendOutlined } from "@ant-design/icons";
import { LightText, MultiLineText, NormalText } from "../components/Typography";
import { endpoint } from "../graphql";
import { ChatItem } from "../components/chatItem";
import { IChatItem } from "../common/types";
import { CardCover } from "../components/Layout";
import moment from "moment";
import { useEffect } from "react";

type Props = {};

const head = {
  borderColor: "#FA8C16",
  color: "#fe6a00",
  fontSize: "1.3em",
  fontWeight: "bold",
};

export const DisplayTicket: React.FC<Props> = (props: Props) => {
  const [createCommentMutation] = useCreateCommentMutation();
  const [searchParams] = useSearchParams();
  const ticketName = searchParams.get("name")!;
  const { data: ticket } = useGetTicketQuery({
    variables: { ticket: ticketName },
  });
  const { data: comments, refetch } = useListCommentsQuery({
    variables: {
      ticket: ticketName,
    },
  });
  const [form] = Form.useForm();
  const { data: comment } = useCommentAddedSubscription({
    variables: {
      ticket_name: ticketName,
    },
  });
  useEffect(() => {
    refetch().then(() => {
      window.document.getElementById("box")?.scrollBy({
        top: 99999,
        behavior: "smooth",
      });
    });
    console.log("new comment aded");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment?.commentAdded]);

  const chatItems: IChatItem[] = [];
  if (ticket?.getTicket.attachmentsUrl)
    chatItems.push(
      ...ticket?.getTicket.attachmentsUrl?.map((rec) => {
        return {
          type: "attachment" as const,
          data: { ...rec },
          username: ticket?.getTicket.username,
          email: ticket?.getTicket.email,
          time: new Date(ticket?.getTicket.createdAt).toLocaleString(),
        };
      })
    );
  if (comments?.commentList)
    for (let i = 0; i < comments.commentList.length; i++) {
      const comment = comments.commentList[i];
      console.log(comment.comment.length);

      if (comment.comment) {
        chatItems.push({
          type: "text" as const,
          data: comment.comment,
          username: comment.username,
          email: comment.email,
          time: new Date(comment.createdAt).toLocaleString(),
        });
      }
      if (comment.attachmentsUrl) {
        chatItems.push(
          ...comment.attachmentsUrl?.map((rec) => {
            return {
              type: "attachment" as const,
              data: { ...rec },
              username: comment.username,
              email: comment.email,
              time: new Date(comment.createdAt).toLocaleString(),
            };
          })
        );
      }
    }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const onFinish = async (values: any) => {
    form.resetFields();
    try {
      const attachments: any = [];
      for (let i = 0; i < values.attachments?.length; i++) {
        const element = values.attachments[i];
        attachments.push({
          base64: await toBase64(element),
          fileName: element.name,
        });
      }
      await createCommentMutation({
        variables: {
          ticket_name: ticketName,
          comment: values.comment || "",
          attachments: attachments,
        },
      });
      // window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e?.fileList;
  };

  function beforeUpload(file) {
    const isLt100M = file.size / 1024 / 1024 < 101;
    if (!isLt100M) {
      notification["error"]({
        message: `File must smaller than 100MB!`,
      });
    }
    return isLt100M || Upload.LIST_IGNORE;
  }

  return (
    <Row align="top" justify="center" gutter={[8, 8]}>
      <Col
        md={{ span: 16, order: 0 }}
        sm={{ span: 24, order: 1 }}
        xs={{ span: 24, order: 1 }}
      >
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Card
              className="communication-card"
              headStyle={head}
              bordered={true}
              cover={
                <CardCover>
                  <NormalText bold color="primary">
                    Subject :
                  </NormalText>
                  <NormalText>{ticket?.getTicket.subject}</NormalText>
                  <NormalText bold color="primary">
                    Description :
                  </NormalText>
                  <MultiLineText>{ticket?.getTicket.description}</MultiLineText>
                </CardCover>
              }
            >
              <div className="communication-box" id="box">
                {chatItems.map((rec) => (
                  <ChatItem
                    type={rec.type}
                    data={rec.data}
                    username={rec.username}
                    email={rec.email}
                    time={rec.time}
                  ></ChatItem>
                ))}
              </div>

              {<Divider plain={false} />}
              <Row gutter={[5, 5]} justify="center" align="middle">
                <Form
                  name="comment"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  form={form}
                  layout="inline"
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  style={{
                    paddingTop: "15px",
                    width: "100%",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <Col md={19} xs={15}>
                    <Form.Item name="comment" style={{ margin: "auto" }}>
                      <TextArea
                        style={{
                          borderRadius: "5px",
                          resize: "none",
                        }}
                        rows={2}
                        placeholder="Write Your Comment..."
                      />
                    </Form.Item>
                  </Col>

                  <Col md={3} xs={6}>
                    <Form.Item style={{ margin: "auto" }}>
                      <Tooltip title="Send">
                        <Button
                          size="large"
                          shape="circle"
                          htmlType="submit"
                          type="primary"
                          icon={<SendOutlined />}
                        ></Button>
                      </Tooltip>
                    </Form.Item>
                  </Col>

                  <Col>
                    <Form.Item
                      name="attachments"
                      getValueFromEvent={normFile}
                      style={{ marginTop: 9 }}
                    >
                      <Upload
                        listType="picture-card"
                        action={`${endpoint}/upload`}
                        maxCount={1}
                        beforeUpload={beforeUpload}
                      >
                        <div>
                          <PlusOutlined />
                          <LightText size={1} style={{ marginTop: 8 }}>
                            Upload
                          </LightText>
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Form>
              </Row>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col md={8} sm={24} xs={24}>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Badge.Ribbon
              text={ticket?.getTicket.status}
              color={
                ticket?.getTicket.status === "New"
                  ? "green"
                  : ticket?.getTicket.status === "Closed"
                  ? "geekblue"
                  : "yellow"
              }
            >
              <Card
                className="communication-card"
                headStyle={head}
                title="Ticket Details"
                bordered={true}
              >
                <Row>
                  <Col span={12}>
                    <NormalText bold>Ticket Name: </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText>{ticket?.getTicket.name} </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText bold>Category: </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText>{ticket?.getTicket.category} </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText bold>Sub-Category: </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText>{ticket?.getTicket.sub_category} </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText bold>Created By: </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText>{ticket?.getTicket.username} </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText bold>User Phone: </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText>{ticket?.getTicket.phone} </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText bold>User Email: </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText>{ticket?.getTicket.email} </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText bold>Date Created: </NormalText>
                  </Col>
                  <Col span={12}>
                    <NormalText>
                      {moment(
                        new Date(ticket?.getTicket.createdAt).getTime()
                      ).format("DD/MM/YYYY - hh:mm A")}{" "}
                    </NormalText>
                  </Col>
                  {ticket?.getTicket.closedAt ? (
                    <>
                      <Col span={12}>
                        <NormalText bold>Date Closed: </NormalText>
                      </Col>
                      <Col span={12}>
                        <NormalText>
                          {moment(
                            new Date(ticket?.getTicket.closedAt).getTime()
                          ).format("DD/MM/YYYY - hh:mm A")}{" "}
                        </NormalText>
                      </Col>
                    </>
                  ) : (
                    <></>
                  )}
                  {ticket?.getTicket.contactTime &&
                     <Col span={20} style={{marginTop:'10px'}}>
                      <NormalText bold>Preferred Contact Times: </NormalText>
                       {ticket?.getTicket.contactTime?.map((rec) => {
                          return (
                           <NormalText> {rec} </NormalText>
                          )
                       })}
                     </Col>
                  }
                </Row>
              </Card>
            </Badge.Ribbon>
          </Col>
          <Col span={24}>
            <Card
              className="communication-card "
              headStyle={head}
              title="Attachement"
            >
              {ticket?.getTicket.attachmentsUrl?.map((rec) => (
                <NormalText>
                  <a href={rec.url}>{rec.fileName}</a>
                </NormalText>
              ))}
              {comments?.commentList.map((comment) => {
                return comment.attachmentsUrl?.map((rec) => (
                  <NormalText>
                    <a href={rec.url}>{rec.fileName}</a>
                  </NormalText>
                ));
              })}
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
